import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ExpandMoreProps {
  expand: number;
}

export const Card = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '6px',
  background: 'rgba(239, 239, 244, 1)',
}));

export const Container = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '14px 20px 10px 25px',
  gap: '15px',
}));

export const CardHeader = styled(Box)(() => ({
  display: 'flex',
  gap: '15px',
  alignItems: 'center',
}));

export const Number = styled(Typography)(() => ({
  position: 'absolute',
  bottom: '4px',
  right: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: '14.3px',
  fontSize: '11px',
  fontWeight: '700',
  color: 'rgba(255, 255, 255, 1)',
  background: 'rgba(34, 40, 34, 1)',
  borderRadius: '50%',
  height: '15px',
  width: '15px',
}));

export const IconsContainer = styled(Box)(() => ({
  position: 'relative',

  svg: {
    width: '40px',
    height: '40px',
  },
}));

export const ExpandMore = styled(IconButton)<ExpandMoreProps>(
  ({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),

    '.MuiSvgIcon-root': {
      fill: expand ? 'rgba(34, 40, 34, 1)' : 'rgba(159, 159, 159, 1)',
    },
  }),
);

export const CollapseContent = styled(Box)(() => ({
  padding: '5px 10px 15px',
}));

export const ViewButton = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  borderRadius: '6px',
  padding: '5px 10px 5px 5px',
  border: '1px solid rgba(221, 221, 234, 1)',
  width: 'fit-content',
  background: 'white',
  cursor: 'pointer',

  '.MuiTypography-root': {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20.8px',
  },

  '.MuiSvgIcon-root': {
    color: 'rgba(159, 159, 159, 1)',
  },

  '&:hover': {
    borderColor: 'rgba(30, 237, 159, 1)',
  },

  '&:active': {
    borderColor: 'rgba(30, 217, 147, 1)',

    '.MuiSvgIcon-root': {
      color: 'rgba(34, 40, 34, 1)',
    },
  },
}));

export const Loader = styled(CircularProgress)(() => ({
  margin: '14px auto',
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  padding: '0 10px 10px',
}));
